export default {
  "fr": {
    "lead": {
      "actions": {
        "add_company": "Ajouter une entreprise",
        "add_lead": "Ajouter un prospect",
        "new": "Nouveau Prospect"
      },
      "attributes": {
        "address": "Adresse",
        "birth_date": "Date de naissance",
        "categories": {
          "enduser": "Acheteur-occupant",
          "investor": "Investisseur"
        },
        "category": "Type de prospect",
        "company_name": "Nom de l'entreprise",
        "company_vat": "numéro de TVA",
        "email_address": "E-mail",
        "first_name": "Prénom",
        "iban": "IBAN",
        "internal_note": "Note interne",
        "language": "Langue",
        "last_name": "Nom de famille",
        "phone_landline": "Numéro de téléphone fixe",
        "phone_mobile": "Numéro de portable",
        "status": "Statut"
      },
      "labels": {
        "detailed_information": "Entrez les informations détaillées",
        "lead": "Plomb"
      },
      "validation": {
        "needFirstName": "Prénom (obligatoire",
        "needLastName": "Nom de famille requis"
      }
    }
  }
}